export default __webpack_public_path__ + "static/media/icomoon.d0607432.ttf";